// src/services/api/procurement/returnToVendor.js
// Endpoints per rettzy-backend/src/modules/procurement/routes/returnToVendor.routes.js
import { apiClient } from '../base';

export const getReturnsToVendor = async (params = {}) => {
  const response = await apiClient.get('/procurement/return-to-vendor', { params });
  return response.data;
};

export const getReturnToVendor = async (rtvId) => {
  const response = await apiClient.get(`/procurement/return-to-vendor/${rtvId}`);
  return response.data;
};

export const createReturnToVendor = async (data) => {
  const response = await apiClient.post('/procurement/return-to-vendor', data);
  return response.data;
};

export const voidReturnToVendor = async (rtvId, data) => {
  const response = await apiClient.post(`/procurement/return-to-vendor/${rtvId}/void`, data);
  return response.data;
};
